import React from 'react';
import PropTypes from 'prop-types';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** Format last-contact like lighthouse proto: "Sep 12" or "2y ago". */
export function formatActivityLabel(isoOrDate) {
  if (!isoOrDate) return null;
  const date = new Date(isoOrDate);
  if (Number.isNaN(date.getTime())) {
    const raw = String(isoOrDate).trim();
    return raw || null;
  }
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const contactDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const daysDiff = Math.floor((today - contactDay) / 86400000);
  if (daysDiff < 365) {
    return `${MONTHS[date.getMonth()]} ${date.getDate()}`;
  }
  const years = Math.max(1, Math.floor(daysDiff / 365));
  return `${years}y ago`;
}

export function ActivityCell({ at = null, frontUrl = null }) {
  const label = formatActivityLabel(at);
  if (!label) {
    return <span className="onyx-activity-empty">—</span>;
  }
  return (
    <span className="onyx-activity-cell" data-testid="onyx-activity-cell">
      <span className="onyx-activity-value">{label}</span>
      {frontUrl ? (
        <a
          className="onyx-activity-link"
          href={frontUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Open Front conversation"
        >
          ↗
        </a>
      ) : null}
    </span>
  );
}

ActivityCell.propTypes = {
  at: PropTypes.string,
  frontUrl: PropTypes.string,
};
